import React  from "react";
import TrainingModuleRequestTable from "./components/TrainingModuleRequestTable";
import { connect } from "react-redux";


const TrainingModuleRequests = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<TrainingModuleRequestTable />
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleRequests);